import React from 'react';
import queryString from 'query-string';
import { getAllItems } from '../service/ItemService';
import { getUserToken } from '../service/UserService';
import ClipLoader from "react-spinners/ClipLoader";
import axios from 'axios';
import {config } from '../config';
import ColorPicker from "../components/ColorPicker";
import { ToastContainer, toast } from 'react-toastify';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ItemPickerDD2 from '../components/ItemPickerDD2';
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";

export default class EditItem extends React.Component {
    constructor(props) {
		super(props);
		this.state = {
            items: null,
            item: {
                id: -1,
                name:"",
                problem_name: "",
                description: "",
                available_cultures: "",
                proposed_time : "",
                agent: "",
                deadline : new Date(),
                isactive: true,
                color : "",
                listorder : "",
                pagecontent: ""
            }
            
		};
    }
    
    componentDidMount(){
        this.loadItems();
    }

    loadItems = () =>{
        const { termek } = queryString.parse(window.location.search);
        
        getAllItems().then(data => {
            //console.log("get termek:", data);
            if(termek){
                this.setState({item: data.find(t=>t.id === termek)});
            }
            else{
                this.setState({items: data});
            }
            
        });
        this.setState({itemid: termek});
    }

    handleSubmitClick = (e) => {
        e.preventDefault();
        let url = config.API_URL + '/Item/edit.php';
        console.log("item", this.state.item);
        if (this.state.item.id == "" || this.state.item.id == 0) {
            url = config.API_URL + '/Item/add.php';
        }

        console.log("calling url:" + url);
        //console.log("JSON.stringify(this.state.item):", JSON.stringify(this.state.item));
        //toast("Termék módosítása ...");
        axios({
            method: 'post',
            url: url,
            //headers: { 'content-type': 'application/json' },
            data: JSON.stringify({item:this.state.item, token: getUserToken()})
          })
          .then(result => {
            console.log("result", result);
            if(result.data.status === true){
              //alert("success");
              toast("Kísérlet elmentve", {type:'info'});
            }
            else{
                alert("error: " + result.data.message);
            } 
          })
          .catch(error => alert(error.message));
    }
    selectItem = (item) =>{
        this.setState({item});
    }

    handleBack = (e) => {
        this.setState({items: null,item: {id: -1}},
            this.loadItems);
        this.props.history.push('/termekszerkesztes');
    }
    setDeadline(date){
        let formattedDate = date.getFullYear() + "-" + 
             ('0' + (date.getMonth()+1)).slice(-2)  + "-" + 
             ('0' + date.getDate()).slice(-2);
        this.setState({item: {...this.state.item, deadline : formattedDate}});
    }
    itemSelected(itemid){
        this.setState({item: this.state.items.find(i=>i.id === itemid)});
    }

    newItem(){
        this.setState({
            item: {
                id: 0, 
                name:"",
                problem_name: "",
                description: "",
                available_cultures: "",
                proposed_time : "",
                agent: "",
                deadline : new Date(),
                isactive: true,
                color : "",
                dose: "",
                type: "",
                listorder : 0,
                pagecontent:""
            }
        });
    }

    handleChange = (name, value) => {
        this.setState({item: {...this.state.item, pagecontent: value}});
    };

    handleSave = () => {
        localStorage.setItem("staticPageContent", JSON.stringify(this.state.item.pagecontent));
        //onSave(editableContent);
    };

    render() {
        return(
            <div style={{paddingBottom:30}}>
                <ClipLoader loading={this.state.item.id === -1 && !this.state.items} size={80} />
                {this.state.items &&  
                    <div className="kwizda-edititem-filter">
                        <div style={{display:'inline-block'}}>
                        <ItemPickerDD2 defaultText={"Kísérletek"}
                            itemSelected={(itemid)=> this.itemSelected(itemid)}></ItemPickerDD2>
                        </div>
                        <div className="kwizda-edititem-filter-text">Válasszon kísérletet a szerkesztés megkezdéséhez</div>
                        <button onClick={() => this.newItem()} style={{float:"right"}} className="kwizda-button"> Új kísérlet </button>
                    </div>
                }
                {(this.state.item.id !== -1) &&
                <div id="kwizda-edit-item" className="row kwizda-form">
                    <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                        <div className="card ">
                            <h4>Kísérlet adatlap</h4>
                            <label>Kísérlet neve ({this.state.item.id})</label>
                            <input type="text" value={this.state.item.name} 
                                onChange={(e) => this.setState({item: {...this.state.item, name: e.target.value}})}></input>
                            <label>Probléma megnevezése</label>
                            <input type="text" value={this.state.item.problem_name} 
                                onChange={(e) => this.setState({item: {...this.state.item, problem_name: e.target.value}})}></input>
                            <label>Probléma leírása</label>
                            <textarea type="text" rows="4" value={this.state.item.description} 
                                onChange={(e) => this.setState({item: {...this.state.item, description: e.target.value}})}>
                            </textarea>
                            <label>Sorrend</label>
                            <input type="text" value={this.state.item.listorder} 
                                onChange={(e) => this.setState({item: {...this.state.item, listorder: e.target.value}})}></input>
                        </div>
                    </div>
                    <div className="kwizda-form-column col-6 login-card mt-2 hv-center">
                        <div className="card">
                            <label>Kísérlet megvalósítás időzítése</label>
                            <input type="text" value={this.state.item.proposed_time } 
                                onChange={(e) => this.setState({item: {...this.state.item, proposed_time : e.target.value}})}></input>
                            <label>Megvalósítás helye</label>
                            <input type="text" value={this.state.item.agent} 
                                onChange={(e) => this.setState({item: {...this.state.item, agent: e.target.value}})}></input>
                            <label>Helyszínek száma</label>
                            <input type="text" value={this.state.item.dose} 
                                onChange={(e) => this.setState({item: {...this.state.item, dose: e.target.value}})}></input>
                            <label>Dokumentáció módja</label>
                            <input type="text" value={this.state.item.type} 
                                onChange={(e) => this.setState({item: {...this.state.item, type: e.target.value}})}></input>
                            <label>Jelentkezési határidő</label>
                            <DatePicker dateFormat="yyyy-MM-dd" selected={new Date(this.state.item.deadline )} 
                            onChange={(date) => this.setDeadline(date)} />
                            <label>Kísérlet láthatósága</label>
                            <div>
                                <input className="kwizda-active-input" onChange={(e) => this.setState({item: {...this.state.item, isactive : e.target.checked}})}
                                type="checkbox" checked={this.state.item.isactive === "1" || this.state.item.isactive === true} >
                                </input><span className="kwizda-active-input-label" 
                                    style={{backgroundColor:this.state.item.isactive === "1"?"":"grey"}}>
                                    {this.state.item.isactive === "1"?"Aktív":"Inaktív"}</span>
                            </div>
                            <h4>Kísérlet szín kiválasztása</h4>
                            <ColorPicker value={this.state.item.color} 
                                onChange={(color) => this.setState({item: {...this.state.item, color: color}})}></ColorPicker>
                            
                            <br/>
                            <div className="kwizda-edit-form-buttons">
                                <button id="kwizda-saveitem-button" 
                                    type="submit" 
                                    className="kwizda-button"
                                    onClick={(e) => this.handleSubmitClick(e)}
                                >Mentés</button>
                                <button style={{width:120, float: 'right', fontSize:14, borderRadius:0, marginLeft:10}}
                                    type="button" 
                                    className="kwizda-back-button"
                                    onClick={(e) => this.handleBack(e)}
                                >Vissza</button>
                            </div>
                        </div>
                    </div>
                    <div className="kwizda-form-column col-12 login-card mt-2 hv-center">
                        <label className="block mb-2">Oldal tartalma:</label>
                        <br/>
                        <ReactQuill
                            value={this.state.item.pagecontent}
                            
                            onChange={(value) => this.handleChange("pagecontent", value)}
                            className="border p-2 w-full mb-4 h-24"
                            modules={{
                                toolbar: [
                                    [{ 'header': [] }, { 'font': [] }],
                                    [{ size: [] }],
                                    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                    [
                                        { 'list': 'ordered' },
                                        { 'list': 'bullet' },
                                        { 'indent': '-1' },
                                        { 'indent': '+1' },
                                    ],
                                    ['link', 'image', 'video'],
                                    ['clean'],
                                    [{ 'color': [] }, { 'background': [] }],
                                    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                                    // [],
                                ]
                                
                                
                            }}
                        />
                        <br/>
                    </div>
                </div>
                }
                <ToastContainer />
            </div>
        )
    }
}